








































































































































































import {Vue, Component, Provide, Watch} from 'vue-property-decorator';
import {mapActions} from 'vuex';
import Role from '@/models/role';
import validator from '@/utils/validator';
import validationMsgs from '@/constants/validation';
import {updateRole, getRolePageGroups, getRoleCompanies, getRoleShips, getRoleById} from '@/services/api/roles';
import {redirectTime} from '@/constants/constants';
import {getShipList, getAllowedShipListForRole} from '@/services/api/common';
import {Utils} from '@/utils/Utils';

@Component({
  computed: {
    getInspectionShip() {
      if (this.utils.isSuperAdmin()) return this.selectedShips;
      else return this.ships;
    },
  },
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
})
export default class EditRole extends Vue {
  roleId: string;
  roleData: Role = {
    groupName: '',
    active: false,
    companyId: -1,
  };

  //loader and helper variables
  isScreenLoading = true;
  saving = false;
  showSuccessToast: any;
  showErrorToast: any;

  allPageGroups: any[] = [];
  ships: any[] = [];
  companies: any[] = [];
  pageGroups: any[] = [];
  selectedShips: any[] = [];
  selectedShipsForInspection: any[] = [];

  //validation variables
  roleNameValidationMsg = null;
  companyValidationMsg = null;
  shipValidationMsg = null;
  inspectionShipValidationMsg = null;
  utils = Utils;

  mounted() {
    this.roleId = this.$route.params.id;
    this.setupRolePage();
  }

  //view setup
  async setupRolePage() {
    try {
      const permsReq = getRolePageGroups();

      let shipsReq = null;
      if (this.utils.isSuperAdmin()) shipsReq = getShipList();
      else if (this.utils.isAdmin()) shipsReq = getAllowedShipListForRole();

      const companiesReq = getRoleCompanies();

      const response = await Promise.all([permsReq, shipsReq, companiesReq]);

      const pageGroupsResponse: any = response[0].data; //groups list
      this.allPageGroups = pageGroupsResponse;
      await this.getRoleData();

      const shipsResponse: [] = response[1].data; //ships list
      this.ships = shipsResponse.map((ship: any) => {
        return {value: ship.shipId, label: ship.name};
      });
      // this.setSelectedShips();
      const companyResponse: any = response[2].response; //company list
      this.companies = companyResponse.data.map((comp: any) => {
        return {id: comp.id, displayName: comp.name};
      });
    } catch (e) {
      //
    }
  }

  //validation functions
  validateRoleName() {
    const name = this.roleData.groupName;
    if (validator.isNullOrEmpty(name)) {
      this.roleNameValidationMsg = validationMsgs.required;
      return false;
    } else {
      this.roleNameValidationMsg = null;
      return true;
    }
  }

  //validate company
  validateCompany() {
    const id = this.roleData.companyId;
    if (id === -1) {
      this.companyValidationMsg = validationMsgs.required;
      return false;
    } else {
      this.companyValidationMsg = null;
      return true;
    }
  }

  //validate ship

  validateShip() {
    if (this.utils.isSuperAdmin()) {
      if (this.selectedShips.length < 1) {
        this.shipValidationMsg = validationMsgs.required;
        return false;
      } else {
        this.shipValidationMsg = null;
        return true;
      }
    } else {
      this.shipValidationMsg = null;
      return true;
    }
  }

  //validate inspection ship

  validateInspectionShip() {
    if (this.selectedShipsForInspection.length < 1) {
      this.inspectionShipValidationMsg = validationMsgs.required;
      return false;
    } else {
      this.inspectionShipValidationMsg = null;
      return true;
    }
  }

  // validating inspection ships are selected in global ship or not
  validateSameShips() {
    let result = null;
    this.selectedShipsForInspection.forEach((data) => {
      if (this.selectedShips.some((me) => me.value === data.value)) {
        this.inspectionShipValidationMsg = '';
        result = true;
      } else {
        this.inspectionShipValidationMsg = 'Selected ships not existed in ships authority';
        result = false;
      }
      return result;
    });
    return result;
  }

  //validate all
  validateAll() {
    return this.validateRoleName() && this.validateCompany() && this.validateInspectionShip() && this.validateShip();
  }

  //fetch data from api
  async getRoleData() {
    try {
      let response = await getRoleById(this.roleId);
      if (response.data) {
        let data = response.data;
        this.mapResponseToRole(data);
        this.setPermissions();
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.isScreenLoading = false;
    }
  }

  //submit button handler
  async updateRoleHandler() {
    if (!this.validateAll()) {
      return;
    }
    let role = {
      GroupName: this.roleData.groupName,
      Active: this.roleData.active,
      PageAuthorities: this.getauthroitiesForPost(),
      Companies: this.getCompaniesForPost(),
    };
    this.saving = true;
    try {
      let response: any = await updateRole(role, this.roleId);
      if (response.data) {
        let message: string = response.message;
        if (message.includes('Successfully updated')) message = 'Record updated successfully';
        this.showSuccessToast({msg: message});
        setTimeout(() => this.$router.go(-1), redirectTime);
      } else {
        let errorMsg = response.error;
        this.showErrorToast({msg: errorMsg});
      }
    } catch (error) {
      console.error(error);

      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.saving = false;
    }
  }

  //helpe methods
  mapResponseToRole(response) {
    if (!response) return;
    const {companies, ships} = response;
    const companyId = companies && companies.length ? companies[0].companyId : -1;
    this.roleData = {
      groupName: response.groupName,
      active: response.active,
      companyId: companyId,
      // ships: ships.map((sh) => sh.shipId),
      groupAuthorities: response.groupAuthorities,
    };
  }

  // set new selected ships
  setNewSelectedShips(groupId, shipsNew) {
    if (groupId === 1)
      this.selectedShipsForInspection = shipsNew.map((me) => {
        return {label: me.shipName, value: me.shipId};
      });
    else if (groupId === 4)
      this.selectedShips = shipsNew.map((me) => {
        return {label: me.shipName, value: me.shipId};
      });
    else return [];
  }
  getShipsForPost(selectedShips) {
    const ships = selectedShips.map((sel) => {
      return {ShipId: sel.value};
    });

    return ships;
  }
  getCompaniesForPost() {
    return [{CompanyId: this.roleData.companyId}];
  }

  //set authority for post
  getauthroitiesForPost() {
    let modifiedGrp = this.pageGroups.map((group) => {
      if (group.pageGroupId === 1) {
        return {
          pageGroupId: group.pageGroupId,
          authoritiesId: group.value,
          ships: this.getShipsForPost(this.selectedShipsForInspection),
        };
      } else if (group.pageGroupId === 4) {
        return {
          pageGroupId: group.pageGroupId,
          authoritiesId: group.value,
          ships: this.getShipsForPost(this.selectedShips),
        };
      } else return {pageGroupId: group.pageGroupId, authoritiesId: group.value};
    });

    return modifiedGrp;
  }

  // set permission based on role
  setPermissions() {
    const perms: any[] = this.roleData.groupAuthorities;

    this.pageGroups = this.allPageGroups.map((group) => {
      const data = perms.find((perm) => group.pageGroupID === perm.pageGroupId);

      this.setNewSelectedShips(group.pageGroupID, data.ships);
      return {
        name: group.pageGroupName,
        pageGroupId: group.pageGroupID,
        showShips: group.pageGroupID === 4,
        options: this.getDisplayValues(group.authorities),
        value: data ? data.authoritiesId : group.authorities[0]['authoritiesId'],
      };
    });
  }

  // show authority options in radio
  getDisplayValues = (auths) => {
    return auths.map((auth) => {
      return {id: auth.authoritiesId, displayName: auth.authorityName};
    });
  };
}
